var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tag',{staticClass:"leak-status-tag",attrs:{"type":_vm.statusType,"size":_vm.size}},[(_vm.showIcon)?_c('i',{staticClass:"status-icon",class:_vm.statusIcon}):_vm._e(),_vm._v(" "+_vm._s(_vm.statusText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }